import { FC } from 'react'

export const NotFoundPage: FC = () => {
  return <>Page not found</>
}
